/**
 * Ensures that `jwt-decode` is available at runtime.
 * Throws a clear error instructing the consumer to install it if not present.
 */
export async function ensureJwtDecode(): Promise<void> {
  try {
    await import('jwt-decode');
  } catch (err) {
    throw new Error(
      '\n[ok-angular-shared/auth] Missing required peer dependency: jwt-decode.\n' +
        'To use the auth entrypoint, please install jwt-decode:\n' +
        '    npm install jwt-decode\n' +
        'See https://github.com/okamba/ok-angular-shared for details.',
      { cause: err }
    );
  }
}
